import { getApi } from "./auth";
import "./globals";
import { objectToQueryString } from "./utils";

const subscribeNewsletterNoConfirm
    = async (_listId: string, _groupId: string, _email: string) => {
        let _data = {
            idLista: _listId,
            groupId: _groupId,
            email: _email
        };
        let queryString = objectToQueryString(_data);
        let url = window.BaseUrlWebApi + "MailUp/IscrizioneGruppoWithOutConfirmation";

        await getApi().fetchWithAuth(`GET ${url}?${queryString}`);
    }

const subscribeNewsletterWithConfirm
    = async (_listId: string, _groupId: string, _email: string, _nome: string, _cognome: string, _telefono: string) => {
        let _data = {
            idLista: _listId,
            groupId: _groupId,
            email: _email,
            nome: _nome,
            cognome: _cognome,
            telefono: _telefono
        };
        let queryString = objectToQueryString(_data);
        let url = window.BaseUrlWebApi + "MailUp/IscrizioneGruppoWithConfirmation";

        await fetch(`${url}?${queryString}`, {
            method: "GET"
        });
    }


const unsubscribeNewsletter
    = async (_listId: string, _email: string) => {
        let _data = {
            idLista: _listId,
            email: _email,
        };
        let queryString = objectToQueryString(_data);
        let url = window.BaseUrlWebApi + "MailUp/UnsubscribeFromList";

        await fetch(`${url}?${queryString}`, {
            method: "GET"
        });
    }


export { subscribeNewsletterNoConfirm, subscribeNewsletterWithConfirm, unsubscribeNewsletter };